export default __webpack_public_path__ + "static/media/collab-image.32a4f73d.svg";